/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { P, TextBlock } from "@cd2/text/build/es6"
import { formatDate } from "@cd2/tools"
import { HelpPopOut } from "./HelpPopOut"

interface ILabelInfoProps {
  label?: React.ReactNode
  value?: React.ReactNode | { date?: string; format?: string }
  light?: boolean
  inline?: boolean
  labelWidth?: number
  returnNullOnEmpty?: boolean
  help?: React.ReactNode
}

export function LabelInfo({
  label,
  value,
  light,
  labelWidth,
  inline,
  returnNullOnEmpty,
  help,
}: ILabelInfoProps) {
  if (returnNullOnEmpty && !value) {
    return null
  }

  return (
    <TextBlock blockSpacing={0}>
      <div
        css={
          inline
            ? css`
                display: flex;
                align-items: baseline;
                gap: 8px;

                > * {
                  flex: 1;
                }
              `
            : undefined
        }
      >
        {label && (
          <div
            css={[
              labelWidth
                ? css`
                    max-width: ${labelWidth}px;
                    min-width: ${labelWidth}px !important;
                  `
                : undefined,
              css`
                display: flex;
                align-items: center;
                gap: 4px;
              `,
            ]}
          >
            <P size="small" weight={600} color={light ? "white" : undefined}>
              {label}
            </P>
            {help && <HelpPopOut>{help}</HelpPopOut>}
          </div>
        )}
        {value ? (
          typeof value === "string" ? (
            <P color={light ? "white" : undefined}>{value}</P>
          ) : typeof value === "object" && "date" in value ? (
            value.date ? (
              formatDate(new Date(value.date), value.format)
            ) : (
              <P color={light ? "white" : undefined}>-</P>
            )
          ) : (
            value
          )
        ) : (
          <P color={light ? "white" : undefined}>-</P>
        )}
      </div>
    </TextBlock>
  )
}
